import styled from 'styled-components';

import { styledReset } from '@pkg/primitives';

export const ResultsWrapper = styled.ol`
    ${styledReset.list}
    --yat_sheet-layout-results-min-width: 140px;

    display: grid;
    gap: 20px;
    grid-template-columns: repeat(auto-fill, minmax(var(--yat_sheet-layout-results-min-width), 1fr));
`;

export const ItemWrapper = styled.li`
    position: relative;
    aspect-ratio: 1/1;
`;
